import {
  createSelector,
  createSlice
} from '@reduxjs/toolkit';

import { updateCallType } from '../ccf-inbox/ccf-inbox.slice';

export const CCF_CALL_CONFERENCE_FEATURE_KEY = 'callConference';

export interface User {
  name: string;
  designation: 'Agent Supervisor' | 'Customer' | 'Technical Support Agent';
  role: 'host' | 'attendee';
}

export type CallType = 'consult' | 'hold' | 'conference';


export interface CallIcons{
  type : 'toggle' | 'action'; 
  icon : React.ReactNode;
  toggleIcon?: React.ReactNode;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dispatcherAction: any;
  // dispatcherAction: ActionCreatorWithoutPayload<string> | ActionCreatorWithPayload<string>;
  className?: string;
}

export interface CallConference {
  status: CallType;
  text: string;
  host: Omit<User,"role"> & { role : 'host' };
  usersInConference: User[];
  userInLobby?: User;
  userInConsult?: User;
  tileDirection: boolean;
}

export interface CallControlAction {
  users: User[];
  type: CallType;
}

const intialState: CallConference = {
  status: 'consult',
  text: 'Consult',
  host:{
    name: 'Gokul Sadanadam',
    designation: 'Agent Supervisor',
    role: 'host',
  },
  usersInConference: [],
  userInLobby: {
      name: 'Liam Davis',
      designation: 'Customer',
      role: 'attendee',
  },
  userInConsult: {
    name: 'Luigi Commetera',
    designation: 'Technical Support Agent',
    role: 'attendee',
  },
  tileDirection: false
}

export const ccfCallSlice = createSlice({
  name: CCF_CALL_CONFERENCE_FEATURE_KEY,
  initialState: intialState,
  reducers: {
    switchUser: (state) => {
      const userInLobby = state.userInLobby;
      const userInConsult = state.userInConsult;
      return {
        ...state,
        userInConsult: userInLobby,
        userInLobby: userInConsult,
        tileDirection: !state.tileDirection,
      };
    },
    addConsultUser: (state, action) => {
      if (state.usersInConference.length > 0) {
        return {
          ...state,
          usersInConference: [...state.usersInConference, action.payload],
        };
      }
      return {
        ...state,
        userInConsult: { ...action.payload, role: 'attendee' },
      };
    },
    addUserToConference: (state) => {
      return {
        ...state,
        status: 'conference',
        text: 'Conference',
        usersInConference: [
          state.userInConsult as User,
          state.userInLobby as User,
        ],
        userInLobby: undefined,
        userInConsult: undefined,
        tileDirection: false,
      };
    },
    resetState: (state) => {
      return {
        ...intialState,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(updateCallType, (state, action) => {
      if (action.payload === 'p2p') {
        return {
          ...intialState,
        };
      }
      return {
        ...state,
      };
    });
  },
});


export const ccfCallReducer = ccfCallSlice.reducer;
export const ccfCallActions = ccfCallSlice.actions;

/**
 * Function to get call Conference data
 * @param rootState - CallConference
 * @returns It returns call Conference
 * @example - const callConference = getCallConferenceState('conference')
 */
const getCallConferenceState = (rootState: { callConference : CallConference }) => {
  return rootState[CCF_CALL_CONFERENCE_FEATURE_KEY];
}

export const selectCallConferenceStatus = createSelector(getCallConferenceState,state =>state.status);
export const selectCallConferenceTitleText = createSelector(getCallConferenceState,state =>state.text);
export const selectTileDirection = createSelector(getCallConferenceState,state =>state.tileDirection);
export const selectUserInConference = createSelector(getCallConferenceState,state =>state.usersInConference);
export const selectUserInConsult = createSelector(getCallConferenceState,state =>state.userInConsult);
export const selectUserInLobby = createSelector(getCallConferenceState,state =>state.userInLobby);